(function () {
  "use strict";

  var CART_DRAWER_SELECTOR = "cart-drawer";

  function isCartDrawerOpen() {
    var drawer = document.querySelector(CART_DRAWER_SELECTOR);
    return drawer ? drawer.classList.contains("is-open") : false;
  }

  function ensurePageScrollable() {
    document.documentElement.removeAttribute("data-scroll-locked");
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }

  function applyScrollLock() {
    document.documentElement.setAttribute("data-scroll-locked", "");
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  function maybeRestoreScrollLock() {
    if (!isCartDrawerOpen()) return;
    var htmlOverflow = document.documentElement.style.overflow;
    var bodyOverflow = document.body.style.overflow;
    if (htmlOverflow !== "hidden" || bodyOverflow !== "hidden") {
      applyScrollLock();
    }
  }

  var observer = new MutationObserver(function () {
    maybeRestoreScrollLock();
  });
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["style"],
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["style"],
  });

  document.addEventListener("theme:cart-drawer:close", function () {
    setTimeout(ensurePageScrollable, 0);
  });
})();
